import React from 'react';

import { IonCol, IonGrid, IonRow } from '@ionic/react';

import { Accordion, AccordionGroup } from 'components/Accordion';
import { DescriptionItem, DescriptionList } from 'components/DescriptionList';
import ApproverListItem from 'scenes/FinancePage/SA/Details/components/Details/components/Approver';
import Status from 'scenes/FinancePage/SA/Details/components/Status';

export default ({ data }: { data: any }) => {
  return (
    <>
      <AccordionGroup>
        <Accordion>
          <DescriptionList data={data}>
            <IonGrid>
              <IonRow>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'period'}
                    label={'Period'}
                    type={'dateRange'}
                    template={'LL'}
                  />
                </IonCol>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'status'}
                    label={'Status'}
                    type={'status'}
                    statusFactory={Status}
                  />
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'affiliate.name'}
                    label={'Affiliate'}
                  />
                </IonCol>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'application.name'}
                    label={'Applications'}
                  />
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size={'6'}>
                  <DescriptionItem field={'net.name'} label={'Network'} />
                </IonCol>
                <IonCol size={'6'}>
                  <DescriptionItem field={'platform.name'} label={'Platform'} />
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'campaigns'}
                    label={'Campaigns'}
                    unitsLabel={'Campaigns'}
                    type={'typographyList'}
                    limit={3}
                  />
                </IonCol>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'amount'}
                    label={'Amount'}
                    type={'amount'}
                  />
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size={'6'}>
                  <DescriptionItem field={'type.name'} label={'Type'} />
                </IonCol>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'adjustmentReason.name'}
                    label={'Reason'}
                  />
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size={'6'} />
                <IonCol size={'6'}>
                  <DescriptionItem
                    label={'Approvers'}
                    field={'approvers'}
                    type={'typographyList'}
                    item={ApproverListItem}
                    placeholder={'-'}
                  />
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size={'6'}>
                  <DescriptionItem
                    label={'Last Updated By'}
                    type={'metadata'}
                    value={data}
                    userField={'updatedBy.name'}
                    dateField={'updatedDate'}
                  />
                </IonCol>
                <IonCol size={'6'}>
                  <DescriptionItem
                    label={'Created By'}
                    type={'metadata'}
                    value={data}
                    userField={'createdBy.name'}
                    dateField={'createdDate'}
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
          </DescriptionList>
        </Accordion>
        <Accordion title={'Statistics'}>
          <DescriptionList data={data}>
            <IonGrid>
              <IonRow>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'initialAmount'}
                    label={'Original amount'}
                    type={'amount'}
                  />
                </IonCol>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'cpi'}
                    label={'CPI'}
                    type={'amount'}
                  />
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size={'6'}>
                  <DescriptionItem
                    field={'regsCount'}
                    label={'Regs'}
                    type={'decimal'}
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
          </DescriptionList>
        </Accordion>
      </AccordionGroup>
    </>
  );
};
